<template>
	<PopupRouterView :showLeftIcon="true" label="Part Good Receipt Input" okTitle="Save" cancelTitle="Cancel"
		entityName="partgoodreceipt" :documentId="mainRecordId" @saveMethod="saveAction" @hideMethod="onHidden"
		ref="partGoodReceiptInput" modalClass="input-scan-page">

		<template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
				<b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

		<div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-purchase-order" ref="fieldset-purchase-order"
							:model.sync="purchaseOrderQrCode" label="Purchase Order" @scannedMethod="scanPurchaseOrder"
							:isBusy="isScanPurchaseOrderLoading" autofocus />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="purchaseOrders != null && purchaseOrders.length > 0">
							<app-list :isDataLoading="isPurchaseOrderPurchaseOrdersLoading"
								:dataCount="purchaseOrders.length">
								<purchase-order-item v-for="(item, index) in purchaseOrders" :model="item" :key="index"
									@nextAction="goToNext(2, item)" :isDisabled="checkIsPurchaseOrderDisabled(item)" />
							</app-list>
						</span>

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label
							v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''"
							label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="GR Number"
							:model="model.partGoodReceiptNumber" />
						<app-input-datepicker id="fieldset-part-good-receipt-date" label-cols-lg="12" label="GR Date"
							size="sm" :model.sync="model.partGoodReceiptDate" :isRequired="true"
							:state="validateState('partGoodReceiptDate')"
							:errorMessage="getErrorMessage(errorMessage.partGoodReceiptDate, 'partGoodReceiptDate')"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							:min="minDate" @change="updateData" />
						<app-input-textbox id="fieldset-surat-jalan" label-cols-lg="12" label="Surat Jalan"
							label-for="input-surat-jalan" size="sm" :model.sync="model.suratJalan" :isRequired="true"
							:state="validateState('suratJalan')"
							:errorMessage="getErrorMessage(errorMessage.suratJalan, 'suratJalan')" @change="updateData"
							:isEditable="true" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
							label-for="input-remark" size="sm" :model.sync="model.remark" @change="updateData" />

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Purchase Order"
							:model="(model.purchaseOrder != null) ? model.purchaseOrder.purchaseOrderNumber : null" />
						<app-input-textbox id="fieldset-part" ref="fieldset-part" :model.sync="partQrCode"
							label="Part Code" :isEditable="true" :isUpdatable="false" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="partGoodReceiptDetails != null && partGoodReceiptDetails.length > 0">
							<app-list :isDataLoading="isPartPartsLoading" :dataCount="partGoodReceiptDetails.length">
								<part-good-receipt-detail-item v-for="(item, index) in partGoodReceiptDetails"
									:model="item" :key="index" @nextAction="goToNext(4, item)"
									:isDisabled="checkIsPartDisabled(item)" />
							</app-list>
						</span>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="partGoodReceiptCasesFiltered != null && partGoodReceiptCasesFiltered.length > 0"
							class="mt-3">
							<h5 class="card-title font-weight-bolder text-dark">Part Good Receipt Case Scanned</h5>
							<div id="container-table-partgoodreceiptcase">
								<b-table id="table-input-partgoodreceipt" head-variant="head-light" :bordered="true"
									:no-local-sorting="true" :items="partGoodReceiptCasesFiltered"
									:fields="fieldsPartGoodReceiptCase" :busy="isDataLoading"
									:sort-by.sync="sortByPartGoodReceiptCase"
									:sort-desc.sync="sortDescPartGoodReceiptCase" small show-empty>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
									</template>
									<template v-slot:cell(part)="row">
										{{ getPartNumSpec(row.item.part) }}
									</template>
									<template v-slot:cell(qtyActual)="row">
										<app-input-textbox-custom id="fieldsetqtyActual" ref="fieldsetqtyActual"
											label-cols-lg="12" label="Qty Inventory" label-for="input-qty-inventory"
											size="sm" :model.sync="row.item.qtyActual" :isEditable="false"
											:state="validateState('qtyActual')" :decimalSeparator="true"
											:errorMessage="getErrorMessage(errorMessage.qtyActual, 'qtyActual')" />
									</template>
									<template v-slot:cell(qtyPo)="row">
										<app-input-textbox-custom id="fieldsetQtyPo" ref="fieldsetQtyPo"
											label-cols-lg="12" label="Qty Po" label-for="input-qty-Po" size="sm"
											:model.sync="row.item.qtyPo" :isEditable="false"
											:state="validateState('qtyPo')" :decimalSeparator="true"
											:errorMessage="getErrorMessage(errorMessage.qtyPo, 'qtyPo')" />
									</template>
								</b-table>
							</div>
						</span>

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 5">
				<b-row>
					<b-col cols="12">
						<app-label
							v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''"
							label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-label label-cols-lg="12" size="sm" label="Part"
							:model="(modelPrint.part != null) ? modelPrint.part.partNumber : null" />
						<app-label label-cols-lg="12" size="sm" label="Supplier Case Number"
							:model="modelPrint.supplierCaseNumber" />
						<app-label label-cols-lg="12" size="sm" label="Qty Inventory" :model="modelPrint.qtyActual" />
						<app-label label-cols-lg="12" size="sm" label="Qty Po" :model="modelPrint.qtyPo" />
						<app-label label-cols-lg="12" size="sm" label="Mcc Number"
							:model="modelPrint.controlCardControlCardNumber" />

					</b-col>
				</b-row>
			</span>
		</div>


		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<!-- <b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right"
				@click="goToNext(2)">Next</b-button> -->
			<b-button
				v-if="scanPageIndex == 2 && (partGoodReceiptCasesFiltered == null || partGoodReceiptCasesFiltered.length <= 0)"
				size="sm" class="btn-fill-danger float-right" @click="goToNext(1)">Back</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right"
				@click="goToNext(3)">Next</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-danger float-right"
				@click="goToNext(2, model.purchaseOrder)">Back</b-button>
			<b-button v-if="scanPageIndex == 3 && showButtonFinish" size="sm" class="btn-fill-success float-right"
				@click="saveAction()">Finish</b-button>
			<b-button v-if="scanPageIndex == 5" size="sm" class="btn-fill-success float-right" @click="printMcc">Print
				MCC</b-button>

		</template>
		<PartGoodReceiptDetailScan :parentLabelInfo="parentLabelInfo" :parentValueInfo="parentValueInfo"
			:model="modelPartGoodReceiptDetail" :modelId="partGoodReceiptDetailId"
			:openPopup="isShowPopupPartGoodReceiptDetail" @resetMethod="resetModal"
			@addButtonMethod="addRowDataPartGoodReceiptDetail" />
		<PartGoodReceiptCaseScan :parentLabelInfo="parentLabelInfo" :parentValueInfo="parentValueInfo"
			:model="modelPartGoodReceiptCase" :modelId="partGoodReceiptCaseId"
			:openPopup="isShowPopupPartGoodReceiptCase" @resetMethod="resetModal"
			@addButtonMethod="addRowDataPartGoodReceiptCase" />

	</PopupRouterView>
</template>
<style scoped>
#container-table-partgoodreceiptcase {
	height: 200px;
	overflow-y: scroll;
	width: 100%;
	overflow-x: scroll;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptList from '@/models/PartGoodReceipt/PartGoodReceiptList';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';
import PurchaseOrderItem from './components/PurchaseOrderItem';
import PartGoodReceiptDetailItem from './components/PartGoodReceiptDetailItem';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';
import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';
import PartGoodReceiptCaseFilter from '@/filters/PartGoodReceipt/PartGoodReceiptCaseFilter';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartGoodReceiptDetailInput from '@/views/PartGoodReceipt/PartGoodReceiptDetailInput';
import PartGoodReceiptDetailScan from '@/views/PartGoodReceipt/PartGoodReceiptDetailScan';
import PartGoodReceiptDetailUpload from '@/views/PartGoodReceipt/PartGoodReceiptDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PartGoodReceiptCaseInput from '@/views/PartGoodReceipt/PartGoodReceiptCaseInput';
import PartGoodReceiptCaseScan from '@/views/PartGoodReceipt/PartGoodReceiptCaseScan';
import PartGoodReceiptCaseUpload from '@/views/PartGoodReceipt/PartGoodReceiptCaseUpload';
import PopupRouterView from '@/components/PopupRouterView';
import VwPartGoodReceiptDetail from '@/models/VwPartGoodReceiptDetail/VwPartGoodReceiptDetail';
import VwPartGoodReceiptDetailFilter from '@/filters/VwPartGoodReceiptDetail/VwPartGoodReceiptDetailFilter';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import AppInputTextboxCustom from '@/components/AppInputTextboxCustom';

export default {
	components: {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PartGoodReceiptDetailInput,
		PartGoodReceiptDetailScan,
		PartGoodReceiptDetailUpload,
		PartGoodReceiptCaseInput,
		PartGoodReceiptCaseScan,
		PartGoodReceiptCaseUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		PurchaseOrderItem,
		PartGoodReceiptDetailItem,
		AppInputTextboxCustom,
	},
	mixins: [validationMixin, toast, focusInput],
	validations: {
		model: {
			purchaseOrderId: { required },
			partGoodReceiptDate: { required },
			suratJalan: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				purchaseOrderId: { required: "Purchase Order is Required." },
				partGoodReceiptDate: { required: "GR Date is Required." },
				suratJalan: { required: "Surat Jalan is Required." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPartGoodReceiptDetail: [
				//{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part Code", key: 'part.partNumber', sortable: false } },
				{ "poQtyOutstanding": { "class": "th-po-qty-outstanding", "label": "PoQtyOutstanding", key: 'poQtyOutstanding', sortable: false } },
				{ "qtyReceived": { "class": "th-qty-received last-child", "label": "QtyReceived", key: 'qtyReceived', sortable: false } },
				//{ "remark": { "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: false } },
				//{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fieldsPartGoodReceiptCase: [
				//{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none", stickyColumn: true, } },
				{ "part": {}, "class": "th-part first-child", "label": "Part", key: 'part', sortable: false, stickyColumn: true, },
				{ "supplierCaseNumber": { "class": "th-supplier-case-number", "label": "Supplier Case Number", key: 'supplierCaseNumber', sortable: false, stickyColumn: true, } },
				{ "controlCard": { "class": "th-control-card last-child", "label": "Control Card", key: 'controlCard.controlCardNumber', sortable: false, stickyColumn: true, } },
				{ "qtyActual": { "class": "th-qty-inventory d-stack-none", "label": "Qty Inventory", key: 'qtyActual', sortable: false, stickyColumn: true, } },
				{ "qtyPo": { "class": "th-qty-po d-stack-none", "label": "Qty Po", key: 'qtyPo', sortable: false, stickyColumn: true, } },
				//{ "remark": { "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: false } },
				//{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			currentPage: 1,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			dataPart: [],
			modelPartGoodReceiptDetail: {},
			isShowPopupPartGoodReceiptDetail: false,
			isShowPopupUploadPartGoodReceiptDetail: false,
			isShowPopupPartGoodReceiptDetailScan: false,
			modelPartGoodReceiptCase: {},
			isShowPopupPartGoodReceiptCase: false,
			isShowPopupUploadPartGoodReceiptCase: false,
			isShowPopupPartGoodReceiptCaseScan: false,
			filterPartGoodReceipt: null,
			currentPartGoodReceiptPage: 1,
			partGoodReceiptPageSize: 10,
			sortByPartGoodReceipt: '',
			sortDescPartGoodReceipt: '',
			filterPartGoodReceiptDetail: null,
			currentPartGoodReceiptDetailPage: 1,
			partGoodReceiptDetailPageSize: 10,
			sortByPartGoodReceiptDetail: '',
			sortDescPartGoodReceiptDetail: '',
			sortingByPartGoodReceiptDetail: [],
			partGoodReceiptDetails: [],
			partGoodReceiptDetailId: '',
			totalPartGoodReceiptDetailRow: 0,
			isShowPartGoodReceiptDetailFilter: false,
			isDownloadPartGoodReceiptDetail: false,
			filterPartGoodReceiptCase: null,
			currentPartGoodReceiptCasePage: 1,
			partGoodReceiptCasePageSize: 10,
			sortByPartGoodReceiptCase: '',
			sortDescPartGoodReceiptCase: '',
			sortingByPartGoodReceiptCase: [],
			partGoodReceiptCases: [],
			partGoodReceiptCaseId: '',
			totalPartGoodReceiptCaseRow: 0,
			isShowPartGoodReceiptCaseFilter: false,
			isDownloadPartGoodReceiptCase: false,
			purchaseOrderDetails: [],
			parts: [],
			controlCards: [],
			partGoodReceiptDetails: [],
			purchaseOrders: [],
			isPurchaseOrderComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isPurchaseOrderComboLoading: false,
			isPartGoodReceiptComboLoading: false,
			isPurchaseOrderDetailComboLoading: false,
			isPartComboLoading: false,
			isControlCardComboLoading: false,
			isPartGoodReceiptDetailComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: 'Purchase Order',
			parentValueInfo: '',
			purchaseOrderQrCode: '',
			isScanPurchaseOrderLoading: false,
			isPurchaseOrderPurchaseOrdersLoading: false,
			purchaseOrderPurchaseOrders: [],
			partQrCode: '',
			isScanPartLoading: false,
			isPartPartsLoading: false,
			partParts: [],
			partGoodReceiptCasesFiltered: [],
			showButtonFinish: false,
			minDate: new Date(),
			modelPrint: {},
			partClassifications: [],
		}
	},
	methods: {
		getPartNumSpec(part) {
			if (part == null) {
				return '';
			} else if (part.partNumber != null && part.partSpecification != null) {
				return part.partNumber + ' - ' + part.partSpecification;
			} else if (part.partNumber != null && part.partSpecification == null) {
				return part.partNumber;
			} else if (part.partNumber == null && part.partSpecification != null) {
				return part.partSpecification;
			}
		},
		getPartClassifications: async function (input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			try {
				var datalist = await PartClassification.getList(this, filter, null, 0, 100);
				this.partClassifications = datalist.data;
				return this.partClassifications;
			} catch { }
		},
		getVwPartGoodReceiptDetail: async function (input) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptDetail);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			if (this.sortByPartGoodReceiptDetail != null) {
				this.sortingByPartGoodReceiptDetail[this.sortByPartGoodReceiptDetail] = this.sortDescPartGoodReceiptDetail;
			}
			if (input) {
				filter.partNumber = input;
				filter.partName = input;
			}
			// disable paging start
			let currentPage = (this.currentPartGoodReceiptDetailPage - 1);
			this.partGoodReceiptDetailPageSize = 0;
			// disable paging end
			VwPartGoodReceiptDetail.getListVw(this, filter, this.sortingByPartGoodReceiptDetail, currentPage, this.partGoodReceiptDetailPageSize).then(result => {
				// this.currentPartGoodReceiptDetailPage = currentPage + 1;
				this.partGoodReceiptDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
				);
				this.partGoodReceiptDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
				);
				this.totalPartGoodReceiptDetailRow = result.dataCount;
			}).catch(error => { this.isBusy = false; });
		},
		printMcc: async function () {
			this.isBusy = true;
			var result = await PartGoodReceiptCase.printMcc(this, this.modelPrint.id);
			this.isBusy = false;
			this.goToNext(3, this.model);
		},
		getPartGoodReceipt: async function (id) {
			this.isBusy = true;
			PartGoodReceipt.getData(this, id).then(result => {
				this.model = result;
				if (result.partGoodReceiptDate == null) {
					this.model.partGoodReceiptDate = new Date();
				}
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if (this.model.purchaseOrderId != null) {
					promises.push(
						this.getPurchaseOrder(this.model.purchaseOrderId).then(result => {
							this.goToNext(3);
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartGoodReceipt = true;
			this.filterPartGoodReceipt.id = this.modelId;
			PartGoodReceipt.downloadDataDetail(this, this.filterPartGoodReceipt).then(result => {
				this.isDownloadPartGoodReceipt = false;
			}).catch(error => { this.isDownloadPartGoodReceipt = false; })
		},
		getPartGoodReceiptDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptDetail);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPartGoodReceiptDetail != null) {
				this.sortingByPartGoodReceiptDetail[this.sortByPartGoodReceiptDetail] = this.sortDescPartGoodReceiptDetail;
			}
			let currentPage = (this.currentPartGoodReceiptDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartGoodReceiptDetailRow + 1;
				let page = Math.ceil(totalData / this.partGoodReceiptDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partGoodReceiptDetailPageSize = 0;
			// disable paging end
			PartGoodReceiptDetail.getList(this, filter, this.sortingByPartGoodReceiptDetail, currentPage, this.partGoodReceiptDetailPageSize).then(result => {
				this.currentPartGoodReceiptDetailPage = currentPage + 1;
				this.partGoodReceiptDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
				);
				this.partGoodReceiptDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
				);
				this.totalPartGoodReceiptDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getPartCaseForPrint: async function (model) {
			let filter = new PartGoodReceiptCaseFilter();
			filter.partGoodReceiptId = model.partGoodReceiptId;
			filter.partId = model.partId;
			filter.supplierCaseNumber = model.supplierCaseNumber;
			PartGoodReceiptCase.getList(this, filter, this.sortingByPartGoodReceiptDetail, 0, 10).then(result => {
				this.modelPrint = result.data[0];
			}).catch(error => { });
		},
		getPartGoodReceiptCases: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptCase);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			//filter.draftMode = "1";
			if (this.sortByPartGoodReceiptCase != null) {
				this.sortingByPartGoodReceiptCase[this.sortByPartGoodReceiptCase] = this.sortDescPartGoodReceiptCase;
			}
			let currentPage = (this.currentPartGoodReceiptCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalPartGoodReceiptCaseRow + 1;
				let page = Math.ceil(totalData / this.partGoodReceiptCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partGoodReceiptCasePageSize = 0;
			// disable paging end
			PartGoodReceiptCase.getList(this, filter, this.sortingByPartGoodReceiptCase, currentPage, this.partGoodReceiptCasePageSize).then(result => {
				this.currentPartGoodReceiptCasePage = currentPage + 1;
				this.partGoodReceiptCases = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
				);
				this.partGoodReceiptCasesFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
				);
				this.totalPartGoodReceiptCaseRow = result.dataCount;
				this.showButtonFinish = result.dataCount > 0 ? true : false
			}).catch(error => { });
		},
		getPartGoodReceipts: async function (input) {
			let filter = new PartGoodReceiptFilter();
			if (input != undefined) {
				filter.PurchaseOrder = input;
			}
			this.isPartGoodReceiptComboLoading = true;
			await PartGoodReceipt.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partGoodReceipts = result.data
					}
					this.isPartGoodReceiptComboLoading = false;
				})
				.catch(error => { });
		},
		getPartGoodReceipts: async function (input) {
			let filter = new PartGoodReceiptFilter();
			if (input != undefined) {
				filter.purchaseOrder = input;
			}
			this.isPartGoodReceiptComboLoading = true;
			await PartGoodReceipt.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partGoodReceipts = result.data
					}
					this.isPartGoodReceiptComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
					}
					this.isControlCardComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			filter.poStatusId = "OPEN,IN_PROGRESS";
			filter.statusId = "APPROVED";
			let arrPartClass = [];
			this.partClassifications.forEach(element => {
				let checkData = arrPartClass.find(p => p.id == element.id);
				if (checkData != null) return;
				if (element.code == "RM" || element.code === "COMPONENT") {
					arrPartClass.push(element.id);
				}
			});
			filter.partClassificationFromPr = arrPartClass.join(',').trim();
			await PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPurchaseOrderExecuted(item) {
			let _this = this;
			if (item == undefined || item == null) {
				this.model.purchaseOrderId = null;
				this.model.purchaseOrder = null;
				this.isBusy = true;
				PartGoodReceipt.resetDocument(this, this.model.id).then(result => {
					this.getPartGoodReceipt(this.model.id).then(result => {
						this.getPartGoodReceiptDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.purchaseOrderId = item.id;
				this.model.purchaseOrder = item;

				this.isBusy = true;
				PartGoodReceipt.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
					this.getPartGoodReceipt(this.model.id).then(result => {
						this.getPartGoodReceiptDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPurchaseOrder(item) {
			if (item) {
				var itemId = Number(item.id);
				if (this.model.purchaseOrderId == itemId) return;
			}

			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Part Good Receipt akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.setSelectedPurchaseOrderExecuted(item);
						}
					})
					.catch(err => { })
			} else {
				this.setSelectedPurchaseOrderExecuted(item);
			}
		},
		getPurchaseOrder: async function (id) {
			PurchaseOrder.getData(this, id).then(result => {
				this.model.purchaseOrder = result;
				this.isBusy = false;
				return result;
			}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partGoodReceiptInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PartGoodReceipt.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PartGoodReceipt.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		async updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			model.partGoodReceiptDetail = null;
			model.partGoodReceiptCase = null;
			//model.purchaseOrder = null;
			if (id != '' && id != null && id != undefined) {
				PartGoodReceipt.updateData(this, model, id).then(result => {
					//return this.getPartGoodReceipt(id);
					return result;
				}).catch((error) => {
				});
			}
		},
		onHidden() {
			this.getPartGoodReceipts();
		},
		addRowDataPartGoodReceiptDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPartGoodReceiptDetails(true);
							this.isShowPopupPartGoodReceiptDetail = false;
						})
				} else {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptDetail.createDataDetail(this, model)
						.then(result => {
							this.getPartGoodReceiptDetails(true);
							this.isShowPopupPartGoodReceiptDetail = false;
						})
				}
			}
		},
		async editRowDataPartGoodReceiptDetail(id) {
			this.partGoodReceiptDetailId = id;
			this.isShowPopupPartGoodReceiptDetail = true;
		},
		async deleteRowDataPartGoodReceiptDetail(id) {
			PartGoodReceiptDetail.deleteData(this, id).then(result => { this.getPartGoodReceiptDetails(); });
		},
		async resetDataPartGoodReceiptDetail() {
			this.partGoodReceiptDetailId = "";
			this.isShowPopupPartGoodReceiptDetail = true;
		},
		async addDataPartGoodReceiptDetail() {
			PartGoodReceiptDetail.createData(this, { partGoodReceiptId: this.modelId })
				.then(result => {
					this.getPartGoodReceiptDetails(true);
				})
		},
		async addFromClipboardPartGoodReceiptDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptDetail.addFromClipboard(this, parts).then(result => { this.getPartGoodReceiptDetails() });
			});
		},
		async replaceFromClipboardPartGoodReceiptDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptDetail.replaceFromClipboard(this, parts).then(result => { this.getPartGoodReceiptDetails() });
			});
		},
		showPopupUploadPartGoodReceiptDetail() {
			this.isShowPopupUploadPartGoodReceiptDetail = true;
		},
		uploadDataPartGoodReceiptDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartGoodReceiptDetail = false;
		},
		downloadPartGoodReceiptDetail(modalEvent) {
			this.isDownloadPartGoodReceiptDetail = true;
			this.filterPartGoodReceiptDetail.partGoodReceiptId = this.modelId;
			PartGoodReceiptDetail.downloadDataDetail(this, this.filterPartGoodReceiptDetail).then(result => {
				this.isDownloadPartGoodReceiptDetail = false;
			}).catch(error => { this.isDownloadPartGoodReceiptDetail = false; })
		},
		saveInputPartGoodReceiptDetail(item) {
			if (this.partGoodReceipts != null && this.partGoodReceipts != undefined && this.partGoodReceipts.length > 0) {
				item.partGoodReceipt = this.partGoodReceipts.find(q => q.id == item.partGoodReceiptId);
			}
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartGoodReceiptDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataPartGoodReceiptCase(modalEvent, model) {
			model.partGoodReceiptDetailId = model.id;
			model.id = null;
			if (model != null) {
				model.isScanned = true;
				this.isBusy = true;
				if (model.id != null && model.id != '') {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptCase.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPartGoodReceiptCases(true);
							this.isShowPopupPartGoodReceiptCase = false;
							this.getPartCaseForPrint(model);
							this.isBusy = false;
							this.goToNext(5, model);
						}).catch(error => {
							this.isBusy = false;
							this.isShowPopupPartGoodReceiptCase = true;
						})
				} else {
					// if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails != undefined && this.partGoodReceiptDetails.length > 0) {
					// 	model.partGoodReceiptDetail = this.partGoodReceiptDetails.find(q => q.id == model.partGoodReceiptDetailId);
					// }

					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptCase.createDataDetail(this, model)
						.then(result => {
							this.getPartGoodReceiptCases(true);
							this.isShowPopupPartGoodReceiptCase = false;
							this.getPartCaseForPrint(model);
							this.isBusy = false;
							this.goToNext(5, model);
						}).catch(error => {
							this.isBusy = false;
							this.isShowPopupPartGoodReceiptCase = true;
						})

				}
			}
		},
		async editRowDataPartGoodReceiptCase(id) {
			this.partGoodReceiptCaseId = id;
			this.isShowPopupPartGoodReceiptCase = true;
		},
		async deleteRowDataPartGoodReceiptCase(id) {
			PartGoodReceiptCase.deleteData(this, id).then(result => { this.getPartGoodReceiptCases(); });
		},
		async resetDataPartGoodReceiptCase() {
			this.partGoodReceiptCaseId = "";
			this.isShowPopupPartGoodReceiptCase = true;
		},
		async addDataPartGoodReceiptCase() {
			PartGoodReceiptCase.createData(this, { partGoodReceiptId: this.modelId })
				.then(result => {
					this.getPartGoodReceiptCases(true);
				})
		},
		async addFromClipboardPartGoodReceiptCase() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptCase.addFromClipboard(this, parts).then(result => { this.getPartGoodReceiptCases() });
			});
		},
		async replaceFromClipboardPartGoodReceiptCase() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptCase.replaceFromClipboard(this, parts).then(result => { this.getPartGoodReceiptCases() });
			});
		},
		showPopupUploadPartGoodReceiptCase() {
			this.isShowPopupUploadPartGoodReceiptCase = true;
		},
		uploadDataPartGoodReceiptCase(modalEvent, newDatas) {
			this.isShowPopupUploadPartGoodReceiptCase = false;
		},
		downloadPartGoodReceiptCase(modalEvent) {
			this.isDownloadPartGoodReceiptCase = true;
			this.filterPartGoodReceiptCase.partGoodReceiptId = this.modelId;
			PartGoodReceiptCase.downloadDataDetail(this, this.filterPartGoodReceiptCase).then(result => {
				this.isDownloadPartGoodReceiptCase = false;
			}).catch(error => { this.isDownloadPartGoodReceiptCase = false; })
		},
		saveInputPartGoodReceiptCase(item) {
			if (this.controlCards != null && this.controlCards != undefined && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails != undefined && this.partGoodReceiptDetails.length > 0) {
				item.partGoodReceiptDetail = this.partGoodReceiptDetails.find(q => q.id == item.partGoodReceiptDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartGoodReceiptCase.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPartGoodReceiptDetail = false;
			this.isShowPopupPartGoodReceiptDetail = false;
			if (modalType == 'PartGoodReceiptDetail') {
				this.getPartGoodReceiptDetails();
			}
			this.isShowPopupUploadPartGoodReceiptCase = false;
			this.isShowPopupPartGoodReceiptCase = false;
			if (modalType == 'PartGoodReceiptCase') {
				this.getPartGoodReceiptCases();
			}
			this.purchaseOrderQrCode = '';
			this.partQrCode = '';
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
			}
		},
		async scanPurchaseOrder() {
			try {
				let qrCode = decodeURIComponent(this.purchaseOrderQrCode);
				let id = this.model.id;
				let result = await PartGoodReceipt.scanPurchaseOrder(this, qrCode);
				if (result) {
					this.model.purchaseOrder = result;
					this.goToNext(2, result);
				}
				this.purchaseOrderQrCode = ''
			} catch { this.purchaseOrderQrCode = '' }
		},
		checkIsPurchaseOrderDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		async scanPart() {
			let qrCode = encodeURIComponent(this.partQrCode);
			let this_ = this;
			delete this_.model.id;

			await this.getParts(qrCode).then(() => {
				this_.model.part = this.parts[0];
				this_.model.partId = this.parts[0].id;
				this_.model.partPartNumber = this.part[0].partNumber;
			})
				.catch(error => {

				});

			this_.$http.post('PartGoodReceiptDetail/create/', this_.model)
				.then(async function (response) {
					if (response != null) {
						let result = response.data;
						this_.goToNext(4, result);
						return;
					}

					this_.toast({ message: 'Gagal untuk memproses data', title: 'Error', variant: 'danger' });
				})
				.catch(error => {
					this_.toast({ message: 'Gagal untuk memproses data', title: 'Error', variant: 'danger' });
				});
		},
		checkIsPartDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		setModel(model) {
			this.modelId = model.id;
			this.model = model;
		},
		getPart: async function (id) {
			await Part.getData(this, id)
				.then(result => {
					if (result != null) {
						this.dataPart = result
						console.log("part result", this.dataPart);
					}
					return this.dataPart;
				})
				.catch(error => { });
		},
		async goToNext(page, item) {
			if (page == 1) {
				this.scanPageIndex = page;
			}
			if (page == 2) {
				let filterGoodReceiptOldDraft = new PartGoodReceiptFilter();
				filterGoodReceiptOldDraft.purchaseOrderId = item.id;
				if (item.purchaseOrderId != null) {
					filterGoodReceiptOldDraft.purchaseOrderId = item.purchaseOrderId;
				}
				filterGoodReceiptOldDraft.draftMode = 1;
				let oldPartGoodReceipt = null;
				this.$nextTick(async () => {
					this.focusInput(this, 'ref-input-fieldset-surat-jalan');
				});
				await PartGoodReceipt.getList(this, filterGoodReceiptOldDraft, null, 0, 1)
					.then(result => {
						if (result.data != null && result.data.length != 0) {
							oldPartGoodReceipt = result.data[0];
							if (oldPartGoodReceipt.id == this.model.id) {
								this.scanPageIndex = page;
							} else {
								const msg = `Terdapat data GR yang belum selesai atas PO ${oldPartGoodReceipt.purchaseOrder.purchaseOrderNumber}. Apakah ingin melanjutkan`;
								this.$bvModal.msgBoxConfirm([msg], {
									title: 'Confirmation',
									size: 'sm',
									buttonSize: 'sm',
									okVariant: 'success',
									cancelVariant: 'danger',
									okTitle: 'Yes',
									cancelTitle: 'No',
									footerClass: 'p-2',
									hideHeaderClose: false,
									centered: true
								}).then(value => {
									if (value) {
										this.$router.replace('/partgoodreceipt/scan/' + oldPartGoodReceipt.id, () => {
											PartGoodReceipt.deleteData(this, this.modelId);
											this.setModel(oldPartGoodReceipt)
											this.model.purchaseOrderId = this.model.purchaseOrder.id;
											this.purchaseOrderQrCode = this.model.purchaseOrder.purchaseOrderNumber;
											this.parentValueInfo = this.purchaseOrderQrCode;
											this.getPartGoodReceiptCases();
										});
										this.scanPageIndex = page;
									}
									return;
								}).catch(err => { })
							}
						} else {
							var isDiferencePo = false;
							if (this.model.purchaseOrderId == null || item.id != this.model.purchaseOrderId) {
								this.model.purchaseOrder = item;
								isDiferencePo = true;
							} 
							this.model.purchaseOrderId = this.model.purchaseOrder.id;
							this.purchaseOrderQrCode = this.model.purchaseOrder.purchaseOrderNumber;
							this.parentValueInfo = this.purchaseOrderQrCode;
							if (oldPartGoodReceipt == undefined && this.partGoodReceiptCasesFiltered.length == 0 && this.purchaseOrderQrCode) {
								this.updateData().then(async (result) => {
									try {
										let qrCode = encodeURIComponent(this.purchaseOrderQrCode);
										await PartGoodReceipt.populateDetail(this, this.modelId, qrCode);
										if (isDiferencePo == true) {
											this.model.suratJalan = '';
											this.model.remark = '';
										}
									} catch { }
								});

							}
							this.scanPageIndex = page;
						}
					})
					.catch(error => { });
			}

			if (page == 3) {
				if (this.$v != null && this.$v.model != null) {
					this.$v.model.$touch();
					if (this.$v.model.$anyError) {
						return;
					}
				}
				this.parentValueInfo = this.model.purchaseOrder != null ? this.model.purchaseOrder.purchaseOrderNumber : this.purchaseOrderQrCode;
				this.getVwPartGoodReceiptDetail();
				//this.getPartGoodReceiptDetails();
				this.getPartGoodReceiptCases();
				this.scanPageIndex = page;
				return;
			}

			if (page == 4) {
				let part = await this.getPart(item.partId);
				item.part = this.dataPart;
				this.modelPartGoodReceiptCase = item;
				this.isShowPopupPartGoodReceiptCase = true;
				return;
			}

			if (page == 5) {
				this.getVwPartGoodReceiptDetail();
				this.modelPrint = item;
				this.scanPageIndex = page;
			}

		},
	},
	beforeMount() {
		this.filterPartGoodReceipt = new PartGoodReceiptFilter();
		this.filterPartGoodReceiptDetail = new PartGoodReceiptDetailFilter();
		this.filterPartGoodReceiptCase = new PartGoodReceiptCaseFilter();
		//this.getPartGoodReceipts();
		//this.getPurchaseOrderDetails();
		//this.getParts();
		//this.getControlCards();
		//this.getPartGoodReceiptDetails();
		//this.getPurchaseOrders();
	},
	async mounted() {
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getPartGoodReceipt(id);
		}
		this.$nextTick(async () => {
			await this.getPartClassifications();
			await this.getPurchaseOrders();
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch: {
		purchaseOrderQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPurchaseOrders(newValue);
			} else {
				this.getPurchaseOrders();
			}
		},
		partQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getVwPartGoodReceiptDetail(newValue);
			} else {
				this.getVwPartGoodReceiptDetail();
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
